/**
 * Non-blocking notice for admins when the API and this build disagree about compatibility.
 * Rendered above the routes; everyone else sees nothing (the mismatch is still in the console).
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';

import { useAuth } from '../contexts/AuthContext';
import { useApiCompat } from '../hooks/useApiCompat';

const ApiCompatBanner: React.FC = () => {
  const auth = useAuth();
  const { mismatch } = useApiCompat();
  const isAdmin = Boolean(auth?.isPlatformAdmin || auth?.isTenantAdmin);
  if (!mismatch || !isAdmin) return null;
  return (
    <div
      role="status"
      data-testid="api-compat-banner"
      className="flex items-start gap-2 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-900/30 dark:text-amber-100"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>{mismatch} Deploy the matching release before relying on new features.</span>
    </div>
  );
};

export default ApiCompatBanner;
